// Mock data for Hygiene Command Center

export const getCardIcon = (key) => {
  switch (key) {
    case "total_tasks":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
          <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2" />
        </svg>
      );
    case "completed":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
          <path d="M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />
        </svg>
      );
    case "pending":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
          <circle cx={12} cy={12} r={10} />
          <path d="M12 6v6l4 2" />
        </svg>
      );
    case "missed":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
          <circle cx={12} cy={12} r={10} />
          <path d="M15 9l-6 6M9 9l6 6" />
        </svg>
      );
    case "compliance":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
          <path d="M9 19v-6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm0 0V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v10m-6 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2m0 0V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z" />
        </svg>
      );
    default:
      return null;
  }
};

export const getCardIconType = (key) => {
  switch (key) {
    case "total_tasks":
      return "info";
    case "completed":
      return "success";
    case "pending":
      return "warning";
    case "missed":
      return "danger";
    case "compliance":
      return "info";
    default:
      return "info";
  }
};

export const getCardTitle = (key) => {
  const titles = {
    total_tasks: "Total Tasks",
    completed: "Completed",
    pending: "Pending",
    missed: "Missed",
    compliance: "Compliance",
  };
  return titles[key] || key?.replace(/_/g, " ");
};

export const mockCommandCenterData = {
  summaryStats: {
    total_tasks: {
      value: 150,
      assigned_percentage: "All tasks",
    },
    completed: {
      value: 120,
      assigned_percentage: "80% completed",
    },
    pending: {
      value: 20,
      assigned_percentage: "13.3% pending",
    },
    missed: {
      value: 10,
      assigned_percentage: "6.7% missed",
    },
    compliance: {
      value: "80%",
      assigned_percentage: "Overall performance",
    },
  },

  criticalTasksMatrix: [
    {
      taskId: 1,
      taskName: "Barbell & EZ Curl Bar Sanitization",
      frequency: "Daily",
      gyms: [
        { gymId: 1, gymName: "WTF: Gym Arena, Sector 16 Noida", status: "COMPLETED" },
        { gymId: 2, gymName: "WTF: masimo gym", status: "PENDING" },
        { gymId: 3, gymName: "WTF: Sigma Fitness", status: "MISSED" },
      ],
    },
    {
      taskId: 2,
      taskName: "Benches & Weight Racks Cleaning",
      frequency: "Daily",
      gyms: [
        { gymId: 1, gymName: "WTF: Gym Arena, Sector 16 Noida", status: "COMPLETED" },
        { gymId: 2, gymName: "WTF: masimo gym", status: "COMPLETED" },
        { gymId: 3, gymName: "WTF: Sigma Fitness", status: "PENDING" },
      ],
    },
    {
      taskId: 3,
      taskName: "Boxing Ring & Mat Sanitization",
      frequency: "Daily",
      gyms: [
        { gymId: 1, gymName: "WTF: Gym Arena, Sector 16 Noida", status: "PENDING" },
        { gymId: 2, gymName: "WTF: masimo gym", status: "MISSED" },
        { gymId: 3, gymName: "WTF: Sigma Fitness", status: "COMPLETED" },
      ],
    },
    {
      taskId: 4,
      taskName: "Cable Machine & Pulley System Sanitization",
      frequency: "Daily",
      gyms: [
        { gymId: 1, gymName: "WTF: Gym Arena, Sector 16 Noida", status: "MISSED" },
        { gymId: 2, gymName: "WTF: masimo gym", status: "COMPLETED" },
        { gymId: 3, gymName: "WTF: Sigma Fitness", status: "COMPLETED" },
      ],
    },
    {
      taskId: 5,
      taskName: "Cardio Area Floor Cleaning",
      frequency: "Daily",
      gyms: [
        { gymId: 1, gymName: "WTF: Gym Arena, Sector 16 Noida", status: "COMPLETED" },
        { gymId: 2, gymName: "WTF: masimo gym", status: "PENDING" },
        { gymId: 3, gymName: "WTF: Sigma Fitness", status: "MISSED" },
      ],
    },
    {
      taskId: 6,
      taskName: "Chest Press & Shoulder Press Machine Cleaning",
      frequency: "Daily",
      gyms: [
        { gymId: 1, gymName: "WTF: Gym Arena, Sector 16 Noida", status: "PENDING" },
        { gymId: 2, gymName: "WTF: masimo gym", status: "COMPLETED" },
        { gymId: 3, gymName: "WTF: Sigma Fitness", status: "COMPLETED" },
      ],
    },
    {
      taskId: 7,
      taskName: "CrossFit Box Area Cleaning",
      frequency: "Daily",
      gyms: [
        { gymId: 1, gymName: "WTF: Gym Arena, Sector 16 Noida", status: "MISSED" },
        { gymId: 2, gymName: "WTF: masimo gym", status: "MISSED" },
        { gymId: 3, gymName: "WTF: Sigma Fitness", status: "PENDING" },
      ],
    },
  ],

  gymwiseCompliance: [
    {
      gymId: 1,
      gymName: "WTF: Gym Arena, Sector 16 Noida",
      total: 52,
      completed: 0,
      pending: 52,
      missed: 0,
      compliancePercentage: 0,
      status: "Error",
    },
    {
      gymId: 2,
      gymName: "WTF: masimo gym",
      total: 0,
      completed: 0,
      pending: 0,
      missed: 0,
      compliancePercentage: 0,
      status: "Good",
    },
    {
      gymId: 3,
      gymName: "WTF: Sigma Fitness",
      total: 0,
      completed: 0,
      pending: 0,
      missed: 0,
      compliancePercentage: 0,
      status: "Error",
    },
  ],
};
